/** @jsx jsx */
/* eslint-disable no-use-before-define */
import React from 'react'
import {jsx, css} from '@emotion/core'
import {mediaQueries, Fields, arrayToggle, MUNI_STATES, getId} from '../../../twd'
import DatePicker from '../date-picker'
import useMarketNews from '../use-market-news'
import SearchCounty from './search-county'

export default ({isModal}) => {

    const {
        customSearchType, setCustomSearchType,
        customKeyword, setCustomKeyword,
        customCusip, setCustomCusip,
        customPurpose, setCustomPurpose,
        customState, setCustomState,
        customCity, setCustomCity,
    } = useMarketNews()
    let isKeyword = customSearchType === 'keyword'
    let id = getId()

    React.useEffect(() => {
        let _id = id+ '-search-type-'+ (isKeyword ? 'keyword' : 'cusip')
        let el = document.getElementById(_id)

        if (!el) return
        el.checked = true
    })

    return <React.Fragment>
    <div className="vertical-offset-xs"
        style={{
            padding:'10px',
            backgroundColor:"#f6f6f6"
        }}>
    <div className="row">
    <div className="col-lg-9 col-md-10 col-xs-12">
        <div className="row" css={formCss}>
            <div className="col-md-5">

                <div className="radio radio-inline">
                <input type="radio"
                    id={id + '-search-type-cusip'}
                    name="corporates-market-news-custom-search-type"
                    defaultChecked={!isKeyword}
                    onChange={() => {
                        setCustomSearchType('cusip')
                    }}
                />
                <label htmlFor={id + '-search-type-cusip'}>Issuer/CUSIP</label>
                </div>

                <div className="radio radio-inline">
                <input type="radio"
                    id={id + '-search-type-keyword'}
                    name="corporates-market-news-custom-search-type"
                    defaultChecked={isKeyword}
                    onChange={() => {
                        setCustomSearchType('keyword')
                    }}
                />
                <label htmlFor={id + '-search-type-keyword'}>Keyword</label>
                </div>
            </div>

            <div className="col-md-7">
            <div className="row">

            <div className="form-group col-md-5" style={{ marginBottom:0 }}>
            {
                isKeyword
                ? <React.Fragment>
                <label htmlFor={id + '-search-keyword'}>Keyword</label>
                <input
                type="text"
                id={id+ '-keyword-input'}
                className="form-control"
                value={customKeyword}
                onChange={(e) => { setCustomKeyword(e.target.value) }}
                >
                </input>
                </React.Fragment>
                : <React.Fragment>
                <label htmlFor={id + '-search-cusip'}>Issuer/CUSIP</label>
                <Fields.SearchCusip
                    id={id + '-search-cusip'}
                    dataName="municipals-market-news-search-cusip"
                    value={customCusip}
                    onSelect={a => setCustomCusip(a.value)}
                    onClear={() => setCustomCusip('')}
                    filter={a => a.type==='M'}
                    map={a => ({value:a.cusip, label: `${a.cusip} - ${a.issue}`}) }
                    showIcon={true}
                    className='form-control vertical-offset-xxs'
                />
                </React.Fragment>
            }
            </div>

            <label className="control-label col-md-1 col-xs-12"
                css={labelCss}>or</label>

            <div className="col-md-5 col-xs-12">
            <Fields.SelectMulti
                dataName="municipals-market-news-search-purpose"
                label="Purpose"
                style={{ marginBottom:0 }}
                showSelectAll={true}
                options={BITVORE_PURPOSES}
                values={customPurpose}
                listConfig={{ style:{ minWidth:'240px' }}}
                onSelect={(a) => {
                    if (a.value==='*') {
                        let isAll = customPurpose.length === BITVORE_PURPOSES.length
                        let arr = isAll
                            ? []
                            : BITVORE_PURPOSES.map(a => a.value)
                        setCustomPurpose(arr)
                        return
                    }

                    let arr = arrayToggle(customPurpose, a.value)
                    setCustomPurpose([].concat(arr))
                }} />
            </div>

            </div>
            </div>
        </div>
    </div>
    <div className="col-lg-3 col-md-2 col-xs-12">
        <DatePicker
            dataName="municipals-market-news-search-data-range"
            type="custom"
            size={10}
            style={{ marginBottom:0 }} />
    </div>
    </div>

    <div className="row">
    <div className="col-lg-9 col-md-10 col-xs-12">

        <div className="row">
            <div className="form-group col-md-5" style={{ marginBottom:0 }}>
            <label>Location</label>
            <Fields.Select
                dataName="municipals-market-news-search-state"
                placeholder="State"
                value={customState}
                options={BITVORE_STATES}
                onChange={(a) => {
                    let s = a.target.value
                    setCustomState(s)
                }} />
            </div>

            <div className="col-md-7 col-xs-12">
            <div className="row">
            <div className="form-group col-md-5" style={{ marginBottom:0 }}>
            <label htmlFor={id + '-search-county'}>County</label>
            <SearchCounty
                id={id + '-search-county'}
            />
            </div>

            <div className="col-md-1" css={separatorCss}>&nbsp;</div>

            <div className="form-group col-md-5" style={{ marginBottom:0 }}>
            <label htmlFor={id + '-search-city'}>City</label>
            <input
                type="text"
                id={id + '-search-city'}
                data-name="municipals-market-news-search-city"
                value={customCity}
                className='form-control vertical-offset-xxs'
                onChange={(a) => {
                    setCustomCity(a.target.value)
                }}
            />
            </div>

            </div>
            </div>

       </div>
    </div>

    </div>
    </div>
    </React.Fragment>
}
const labelCss = css`
    ${mediaQueries.xs} {
        text-align:center;
    }
    ${mediaQueries.notXs} {
        margin-top: 20px;
    }
`

const separatorCss = css`
    ${mediaQueries.xs} {
        display:none;
    }

    ${mediaQueries.notXs} {
        display:block;
    }
`

const formCss = css`
    .control-label { text-align:center; }
    ${mediaQueries.xs} {
        .radio, .radio-inline { padding-bottom: 5px; }
    }
    ${mediaQueries.sm} {
        .radio, .radio-inline { padding-bottom: 5px; }
    }
    ${mediaQueries.sm} {
        .radio, .radio-inline { padding-bottom: 5px; }
    }
    ${mediaQueries.notXs} {
        .radio, .radio-inline { margin-top: 20px; }
    }

`


const BITVORE_PURPOSES = [
    {label:'Development', value:'Development'},
    {label:'Education', value:'Education'},
    {label:'Higher Education', value:'HigherEducation'},
    {label:'Primary Secondary Education', value:'PrimarySecondaryEducation'},
    {label:'Health', value:'Health'},
    {label:'Housing', value:'Housing'},
    {label:'Local Government', value:'LocalGov'},
    {label:'Tax Revenue', value:'TaxRevenue'},
    {label:'Transportation', value:'Transportation'},
    {label:'Utility', value:'Utility'}
]

const BITVORE_STATES = [{label:'Any State', value:' '}]
    .concat(MUNI_STATES.map(a => {
        return { ...(a), value:a.value.split('=')[1] }
    }))



// WEBPACK FOOTER //
// ./src/municipals/market-news/custom-search/custom-search.js